module.exports = __webpack_public_path__ + "static/img/icon_city.8813fc06.svg";